import { APP } from './app';
import { USER } from './user';

export const VIEWS = { APP, USER };
